/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react'

import { cookie, r2d2 } from '@components/Ackodrive/common/globals'
import {
  IllogicalFlowWrapper,
  IllogicalFlowText,
  IllogicalFlowLeftContent,
  IllogicalFlowSubText,
  LoginButton,
  IllogicalFlowRightContent,
} from './message.styles'

const IllogicalFlowMessage = ({ show, isLoggedIn }) => {
  const handleLoginClick = () => {
    r2d2({
      ekind: 'car_widget_login_clicked',
      okind: isLoggedIn ? 'myaccount_homepage' : 'tracker',
      oid: cookie('trackerid') || '',
    }).finally(() => (window.location.href = `/login/?next=${process.env.NEXT_PUBLIC_MYACCOUNT_PATH || '/'}`))
  }

  return (
    <IllogicalFlowWrapper key="illogical-message" show={show}>
      <IllogicalFlowLeftContent>
        <IllogicalFlowText>You already have an Acko policy</IllogicalFlowText>
        <IllogicalFlowSubText>Login to access your policy for this car</IllogicalFlowSubText>
      </IllogicalFlowLeftContent>
      <IllogicalFlowRightContent>
        <LoginButton onClick={handleLoginClick}>Login</LoginButton>
      </IllogicalFlowRightContent>
    </IllogicalFlowWrapper>
  )
}

export default IllogicalFlowMessage
